// src/components/BalanceNotification.jsx

import { useNotification } from "./NotificationContext";
import { X, AlertTriangle, Check, XIcon } from 'lucide-react';


export default function BalanceNotification() {
    const { showPopup, closePopup } = useNotification();

    if (!showPopup) return null;

    return (
        <>
            {/* <div className="fixed bottom-4 right-4 bg-red-500 text-white p-4 rounded-lg shadow-lg z-50">
                <p>⚠️ Your account requires balance notification!</p>
                <button
                    className="ml-4 bg-white text-red-500 px-3 py-1 rounded"
                    onClick={closePopup}
                >
                    Dismiss
                </button>
            </div> */}
            <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-4 transform transition-all duration-300 ease-in-out">
                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b border-gray-100">
                            <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                                    <AlertTriangle className="w-5 h-5 text-orange-600" />
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900">Confirm Action</h3>
                            </div>
                            <button
                                onClick={closePopup}
                                className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors duration-200"
                            >
                                <X className="w-4 h-4 text-gray-600" />
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-6">
                            <p className="text-gray-700 text-base leading-relaxed mb-6">
                                ⚠️ Your account requires balance !
                            </p>

                            {/* Action Buttons */}
                            <div className="flex space-x-3">
                                <button
                                    onClick={closePopup}
                                    className="flex-1 px-4 py-3 bg-gradient-to-r from-red-500 to-red-600 text-white font-medium rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <Check className="w-4 h-4" />
                                    <span> Dismiss</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
